<template>
  <div class="container">
    <SimpleHeader :title=title :detail=subtitle />
    <br/>
    <div class="row" v-if="loading">
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando directorio...</span>
        </div>
      </div>
    </div>
    <div class="row" v-if="!loading">
      <div class="col-md-12"
        v-for="item in benefits"
        :key="item.id">
        <BusinessCard :item=item />
      </div>
    </div>
  </div>
</template>

<script>
import SimpleHeader from './SimpleHeader.vue';
import BusinessCard from './BusinessCard.vue';
import axios from 'axios';

export default {
  name: 'Home',
  data() {
    return {
      title: 'Directorio Comunidad K-9',
      subtitle: 'Emprendimientos de nuestros colaboradores',
      benefits: null,
      loading: false,
      bannerUrl: "https://res.cloudinary.com/dbl4yeqf9/image/upload/v1596156183/logos/community_y1vacu.jpg"
    }
  },
  mounted() {
    this.fetchRegisters()
  },
  methods: {
    showMore(benefit) {
      this.isModalActive = true;
      this.selected = benefit;
    },
    fetchRegisters() {
      this.loading = true;
      axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/community/business-register-data`)
        .then(response => {
          this.benefits = response.data
          console.log(this.benefits);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  components: {
    SimpleHeader,
    BusinessCard,
  },
}
</script>

<style scoped>
.text-center {
  margin: auto;
}
.banner-img{
  object-fit: cover;
  max-height: 100%;
  max-width: 100%;
  height: 300px;
  -webkit-filter: grayscale(0%);
  filter: grayscale(0%);
}
</style>

